import axios from "axios";
import { ApiResult } from "@shoothill/core";

export class HttpClient {
    public static async get<TPayload>(url: string): Promise<ApiResult<TPayload>> {
        const response = await axios.get<ApiResult<TPayload>>(url, {
            baseURL: window.location.origin,
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            withCredentials: true,
        });
        return response.data;
    }

    public static async post<TPayload>(url: string, data?: any): Promise<ApiResult<TPayload>> {
        const response = await axios.post<ApiResult<TPayload>>(url, data, {
            baseURL: window.location.origin,
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            withCredentials: true,
        });
        return response.data;
    }
}
